import { render, staticRenderFns } from "./GroupWorkcenterChild.vue?vue&type=template&id=cfabd64e&scoped=true&"
import script from "./GroupWorkcenterChild.vue?vue&type=script&lang=js&"
export * from "./GroupWorkcenterChild.vue?vue&type=script&lang=js&"
import style0 from "./GroupWorkcenterChild.vue?vue&type=style&index=0&id=cfabd64e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfabd64e",
  null
  
)

export default component.exports